import client from './client';
import type { RealtimeQuote, MarketBreadth, PaginatedQuotes, Stock } from '../types';

/**
 * 行情 API 封装
 */

/** 全A股实时行情（分页） */
export async function fetchAllQuotes(
  page: number = 1,
  size: number = 50,
  sort: string = 'changePct',
  order: 'asc' | 'desc' = 'desc',
  search: string = ''
): Promise<PaginatedQuotes> {
  const res = await client.get('/market/all', { params: { page, size, sort, order, search } });
  return res.data;
}

/** 批量指定股票实时行情 */
export async function fetchQuotes(codes: string[]): Promise<RealtimeQuote[]> {
  const res = await client.get('/market/quotes', { params: { codes: codes.join(',') } });
  return res.data;
}

/** 大盘涨跌家数+指数 */
export async function fetchBreadth(): Promise<MarketBreadth> {
  const res = await client.get('/market/breadth');
  return res.data;
}

/** 搜索股票 */
export async function searchStocks(q: string): Promise<Stock[]> {
  const res = await client.get('/market/search', { params: { q } });
  return res.data;
}

/** 今日整体条件锁状态 */
export interface GlobalLockInfo {
  date: string;
  locked: boolean;
  reasons: string[];
  triggered_at: string | null;
}
export async function fetchGlobalLock(): Promise<GlobalLockInfo> {
  const res = await client.get('/global-lock');
  return res.data;
}
